<template>
  <main>
    <div id="product-finder-app" data-category="jacket" :data-view="formattedLocale" @open-quickshop="DialogQuickshop.open({ product: $event.detail, gtmConfig: { appSource: 'jacket-finder' } })">
      <div class="pb-6 pt-8 space-y-4">
        <div class="mx-a h-8 w-1/4 skeleton" />
        <div class="mx-a h-6 w-1/2 skeleton" />
      </div>
      <div class="skeleton pt-10" style="height: 72dvh" />
    </div>
    <dialog-quickshop :size="{ sm: 'full', lg: 'lg' }" :type="{ sm: 'panel', lg: 'modal' }" />
  </main>
</template>

<script lang="ts" setup>
const { configExternalApps: { jacketFinderUrl = '' } } = useFeatureFlags()
const formattedLocale = useFormattedLocale()

useScriptTag(
  jacketFinderUrl,
  undefined,
  {
    attrs: {
      fetchpriority: 'high'
    }
  }
)

useHead({
  bodyAttrs: {
    class: 'hide-chat-button'
  }
})

const DialogQuickshop = createDialog('quickshop')

onMounted(() => setInteractionOrigin('jacket-finder'))
</script>
